const WITH_SCHEME = /^(https?:\/\/|mailto:|tel:)/i;
// `example.com` or `www.example.com/menu`: a web page typed without its https://.
const WEB_ADDRESS = /^(?:[a-z0-9-]+\.)+[a-z]{2,}(?:[/?#]\S*)?$/i;
const EMAIL_ADDRESS = /^[^\s@/:]+@[^\s@/:]+\.[a-z]{2,}$/i;

/**
 * The link as it is stored, or null when the text is none: a web page, an email address or a phone
 * number. A bare address gets its `https://` or `mailto:`, so it never becomes a link relative to the
 * page that shows it.
 */
export const linkHref = (text: string): string | null => {
    const href = text.trim();
    if (!href || /\s/.test(href)) return null;

    if (EMAIL_ADDRESS.test(href)) return `mailto:${href}`;
    if (WEB_ADDRESS.test(href)) return `https://${href}`;
    if (!WITH_SCHEME.test(href)) return null;

    try {
        const url = new URL(href);
        return url.protocol === 'http:' || url.protocol === 'https:' ? (url.hostname ? href : null) : href;
    } catch {
        return null;
    }
};
